import React from 'react'
import ReactDOM from 'react-dom/client'
import App  from './App';
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import Index from './routes/index'
import ReactGA from 'react-ga4'
import Fund from './routes/fund'
import Join from './routes/join'
import {Toaster} from 'react-hot-toast'
import Partner from './routes/partner'
//import Subscribe from './routes/subscribe'
import Feedback from './routes/feedback'
//import Ingredients from './routes/ingredients'
import About from './routes/about'
//import Source from './routes/source'
import Terms from './routes/terms'
//import FAQ from './routes/faq'
import Health from './routes/health'
//import Shop from './routes/shop'
//import Pitch from './routes/pitch'
// import Test from './routes/test.tsx'

const router = createBrowserRouter([
  {
    element: <App />,
    errorElement: <>Error</>,
    children: [
      { path: '/', element: <Index /> },
      { path: '/fund', element: <Fund /> },
      /*{ path: '/subscribe', element: <Subscribe /> },*/
      { path: '/join', element: <Join /> },
      { path: '/partner', element: <Partner /> },
      { path: '/feedback', element: <Feedback /> },
      /*{ path: '/source', element: <Source /> },*/
      { path: '/about', element: <About /> },
      { path: '/terms', element: <Terms /> },
      /*{ path: '/faq', element: <FAQ /> },*/
      /*{ path: '/ingredients', element: <Ingredients /> },*/
      { path: '/health', element: <Health /> },
      /*{ path: '/shop', element: <Shop /> },*/
      /*{ path: '/pitch', element: <Pitch /> },*/
    ]
  }
]);

ReactGA.initialize([
  {
    trackingId: "F-F5VV4ZEYBR", 
  }
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <div><Toaster/></div> {/* ezt felesleges itt tartani */}
    <RouterProvider router={router} />
  </React.StrictMode>,
)